<template>
  <adv-button
    class="addtoCart"
    v-on:btn-click="buttonClick"
    :disabled="disabled"
    :productId="productId"
    :quantity="quantity"
    :is-listing="isListing"
    :is-variation-group-master="isVariationGroupMaster"
    :attribute-ids-with-stock="getAttributeIdsWithStock"
    :product-meta-data="productMetaData"
  >
  </adv-button>
</template>

<script>
import onlineMixin from './mixins/onlineMixin'
import cartButtonMixin from './mixins/cartButtonMixin'
import AdvButton from './presentation/AdvButton'
import { flatten } from 'lodash-es'
import { mapGetters } from 'vuex'
import productMixin from './mixins/productMixins'

export default {
  name: 'AdvCartButton',
  components: {
    AdvButton
  },
  mixins: [onlineMixin, cartButtonMixin, productMixin],
  props: {
    productId: Number,
    quantity: {
      type: Number,
      default: 0
    },
    stock: {
      type: Number,
      default: 1
    },
    unavailable: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Boolean,
      default: false
    },
    cartLimitReached: {
      type: Boolean,
      default: false
    },
    hasAttributes: {
      type: Boolean,
      default: false
    },
    selectedAttributeId: {
      type: Number,
      default: null
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    productMetaData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      version: '0.0.3'
    }
  },
  computed: {
    ...mapGetters(['getProductById']),
    productData () {
      return this.getProductById(this.productId)
    },
    getAttributeIdsWithStock () {
      return flatten(this.productData.productCodes
        .filter(item => item.productStock > 0)
        .map(item => item.productCodeAttributes))
    }
  },
  methods: {
    buttonClick () {
      if (this.stock <= 0 && (!this.isListing && !this.isVariationGroupMaster)) {
        this.$emit('btn-click-no-stock')
      } else if (this.isListing && this.isVariationGroupMaster) {
        this.$emit('btn-click-variation-master')
      } else {
        this.$emit('btn-click')
      }
    }
  }
}
</script>
